<template>
  <v-card>
    <v-card-title class="mx-0">{{value.title}}</v-card-title>
    <v-card-text class="pb-0">
      <v-row class="ma-0">
        <v-col cols="3" class="text-center">
          <v-btn fab small @click="onItemAmountChanged(-1)" :color="'error'">
            <v-icon>fas fa-minus</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="6" class="ma-0">
          <v-text-field class="ma-0 pa-0 centered-input " type="number" hide-details
                        single-line v-model="amount" @click="amount = ''"/>
<!--          <div class="h4 text-center">{{amount}}</div>-->
        </v-col>
        <v-col cols="3" class="text-center">
          <v-btn fab small @click="onItemAmountChanged(1)" :color="'primary'">
            <v-icon>fas fa-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row>
<!--      <v-row>-->
<!--        <v-col>-->
<!--          <div class="h5 text-right">£{{((amount * value.price) / 100).toFixed(2)}}</div>-->
<!--          <div class="h6 text-right">VAT £{{((value.price * value.taxRate/10000)/100 * amount).toFixed(2)}}</div>-->
<!--        </v-col>-->
<!--      </v-row>-->
      <v-row v-if="enableMemo == true">
        <v-col class="pb-0">
          <v-textarea
            rows="4"
            label="MEMO"
            outlined
            placeholder="Input Text"
            v-model="memo"
            clearable
          />
        </v-col>
      </v-row>
<!--      <v-row>-->
<!--        <v-col class="pb-0">-->
<!--          <div class="h5">Add to Basket</div>-->
<!--        </v-col>-->
<!--      </v-row>-->
      <v-row>
        <v-col>
          <v-btn class="pa-7" block color="primary" @click="onClickAdd(value.vendorId)">Add to <br>{{vendorName}} Basket</v-btn>
        </v-col>
<!--        <v-col v-if="item.canOrderKokoro">-->
<!--          <v-btn block @click="onClickAdd(0)">KOKORO</v-btn>-->
<!--        </v-col>-->
<!--        <v-col v-if="item.canOrderVendor">-->
<!--          <v-btn block @click="onClickAdd(value.vendorId)">{{vendorName}}</v-btn>-->
<!--        </v-col>-->
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import {showDialog} from "../api/utils";

  export default {
    name: "DetailProduct",
    props: {
      value: {
        type: Object,
        default: function () {
          return null;
        }
      },
      vendorName: {
        type: String,
        default: function () {
          return null;
        }
      },
      enableMemo: {
        type:Boolean,
        default: function() {
          return true;
        }
      }
    },
    data(){
      return {
        item: this.value,
        amount: 1,
        memo:'',
      }
    },
    watch: {
      value(){
        this.item = this.value
        this.item.description = ""
        this.amount = 1
      }
    },
    computed: {
      rules(){
        const rules = []

        rules.push(this.amount > 0 || "Not Allowed Less than 0")

        return rules
      }
    },
    beforeDestroy() {
    },
    methods: {
      onClickAdd: function(vendorId){
        console.log(vendorId)
        console.log(this.amount);
        if(this.amount == '' || this.amount == 0) {
          console.log("show error");
          showDialog("Please enter amount");
          return;
        }
        for(let rule of this.rules){
          if(rule !== true) return
        }


        this.value.amount = parseInt(this.amount);

        this.$emit('addItem', vendorId, this.memo)
      },
      onItemAmountChanged: function(diff) {
        this.amount = Math.max(this.amount + diff, 1)
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Detail.vue